import { render } from "./VuetifyDataTable.vue?vue&type=template&id=03689730&scoped=true&ts=true"
import script from "./VuetifyDataTable.vue?vue&type=script&lang=ts"
export * from "./VuetifyDataTable.vue?vue&type=script&lang=ts"

import "./VuetifyDataTable.vue?vue&type=style&index=0&id=03689730&scoped=true&lang=css"
import "./VuetifyDataTable.vue?vue&type=style&index=1&id=03689730&lang=css"

import exportComponent from "/codebuild/output/src1078960470/src/pricing_engine_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03689730"]])

export default __exports__